module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Add new choice category",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.categoryForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.categoryForm.title),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "title", $$v)
      },
      expression: "categoryForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.categoryForm.description),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "description", $$v)
      },
      expression: "categoryForm.description"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7046f2b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/ChoiceCategoryCreateDialog.vue
// module id = 3328
// module chunks = 3